import React from 'react';
import "./CustomButton.scss";
const CustomButton = (props) => {
    const {variant, type} = props;
    const className = (variant ? `button-${variant}`: "") +" "+ (type ? `button-${type}`: "")
    return (
        <div onClick={props.onClick} className={`custom-button ${props.className} ${className}`} style={props.style ? props.style : {}}>
            {props.text}
        </div>
    )
}

export default CustomButton;